import React, { useMemo } from "react";
import { Box } from "../../../../../../../shared/Box/Box";
import { Skeleton } from "../../../../../../../shared/Skeleton/Skeleton";
import { Table as SharedTable } from "../../../../../../../shared/Table/Table";
import { Empty } from "../../../../../../../shared/Empty/Empty";
import { LoadMoreObserver } from "../../../../../../../shared/LoadMoreObserver/LoadMoreObserver";
import { useAppTranslation } from "../../../../../../../i18n/useAppTranslation";
import styles from "./styles.module.scss";
import { Actions } from "./shared/Actions";

/**
 * @param {{
 *    data: Array<{
 *      id: number;
 *      name: string;
 *      title: string;
 *      phrase: string;
 *    }>;
 *    statuses: {
 *      isLoading: boolean;
 *      isEmpty: boolean;
 *      isDataVisible: boolean;
 *      hasMoreData: boolean;
 *      isNextDataFetching: boolean;
 *    };
 *    handlers: {
 *      fetchNextPage: () => void;
 *    };
 * }} param0
 */
export const Table = ({ data, statuses, handlers }) => {
  const { tSettings: t } = useAppTranslation.Settings({
    keyPrefix: "smsSnippets.all.table",
  });

  const { isLoading, isEmpty, isDataVisible, hasMoreData, isNextDataFetching } =
    statuses;

  const { fetchNextPage } = handlers;

  const cols = [
    {
      data: t("snippetPhrase"),
      accessor: "name",
      className: styles.col,
    },
    {
      data: t("title"),
      accessor: "title",
      className: styles.col,
    },
    {
      data: t("actions"),
      accessor: "actions",
      className: styles.col,
    },
  ];

  const tableData = useMemo(
    () =>
      data.map((item) => ({
        key: item.id,
        name: item.name,
        title: item.title,
        actions: <Actions id={item.id} />,
      })),
    [data],
  );

  return (
    <Box elevation className={styles.root}>
      {isLoading && <Skeleton count={15} height={50} borderRadius="0px" />}
      {isDataVisible && <SharedTable cols={cols} data={tableData} />}
      {isEmpty && <Empty size="big" position="center" />}
      {hasMoreData && (
        <LoadMoreObserver
          noPaddingBottom
          loadMore={fetchNextPage}
          isLoading={isNextDataFetching}
        />
      )}
    </Box>
  );
};
